<ng-container *transloco="let t">
<div (click)="onEditClicked()"
  class="hidden-when-mobile notice d-flex rounded border-primary border border-dashed min-w-lg-600px align-items-center flex-shrink-0 b-4 p-6 mb-4 btn btn-outline"
  [ngClass]="{
  'btn-outline-dashed' : income.isValid,
  'btn-outline-primary' : income.isValid,
  'btn-active-light-primary': income.isValid,
  'border-danger': !income.isValid,
  'btn-active-light-danger': !income.isValid
}">
  <span class="svg-icon svg-icon-2x svg-icon-primary me-4 align-items-center duotone-home-svg-mobile"
    style="padding-bottom: 2px;"
    [ngClass]="{'svg-icon-primary': income.isValid, 'svg-icon-danger' : !income.isValid }">
    <ng-template svgIconHost></ng-template>
  </span>
  <div class="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap align-items-center">
    <span class="fs-6 text-gray-600 d-block fw-bold" style="min-width: 200px;text-align: left;">{{incomeName}}
      @if (income.digitallyVerified) {
        <span class="badge badge-success" style="margin-left: 12px;">{{ t('wizard.income.verified') }}</span>
      }
      <span class="d-block text-gray-400"> {{!income.isCurrent ? t('wizard.income.former') : ""}} </span>
    </span>
    <div class="d-flex justify-content-end align-items-center">
      <div class="position-relative px-4" style="width: 150px; text-align: left;">
        @if (income.position) {
          <label class="text-gray-600">{{income.isOther ? t('wizard.income.description') : t('wizard.income.position')}}:
            <span class="d-block"> {{income.position}} </span>
          </label>
        }
      </div>
      <div style="width: 130px; text-align: left;">
        @if (income.startDate) {
          <label class="text-gray-600 align-items-center px-4">{{(income.startDate|
            date) + '-' + (income.endDate ? (income.endDate | date) : t('wizard.income.now'))}}</label>
        }
      </div>
      <label class="text-gray-600 px-4" style="min-width: 205px; text-align: left;">{{ t('wizard.income.monthlyPay') }}: {{income.monthlyPay|
        currency}}</label>
      <div class="mx-4" style="width: 175px; min-width: 175px;">
        @if (income.type === 'Base') {
          @for (incomeItem of income.incomeBreakdown; track $index) {
            <div class="income-row">
              <span class="income-title">{{ incomeItem.type }}:</span>
              <span class="income-amount" (click)="onEditIncomeClicked($event)">{{ incomeItem.monthlyPay | currency
                }}</span>
            </div>
          }
          <div class="shown-only-monthly-income-link">
            <span (click)="onEditIncomeClicked($event)"> {{ t('wizard.income.incomeDetails') }} <i class="text-primary fa fa-eye"></i></span>
          </div>
        }
      </div>

      <div class="align-self-center text-nowrap">
        <div class="d-flex">
          <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            (click)="onDeleteClicked($event)">
            <span class="svg-icon svg-icon-3">
              <duotone-trash-svg-icon></duotone-trash-svg-icon>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div (click)="onEditClicked()"
  class="hidden-when-not-mobile align-items-center rounded border-primary border border-dashed min-w-lg-600px mb-4"
  [ngClass]="{'border-danger' : !income.isValid, 'btn-active-light-danger': !income.isValid}"
  style="padding: 5px !important;">
  <span class="svg-icon svg-icon-2x svg-icon-primary me-4 align-items-center duotone-home-svg-mobile"
    style="padding-bottom: 2px;"
    [ngClass]="{'svg-icon-primary': income.isValid, 'svg-icon-danger' : !income.isValid }">
    <ng-template svgIconHost></ng-template>
  </span>
  <div style="width: 100%;">
    <div class="d-flex justify-content-between mx-2">
      <span class="fs-4 text-gray-600 d-block fw-bold mt-3">{{incomeName}}
        @if (income.digitallyVerified) {
          <span class="badge badge-success" style="margin-left: 12px;">{{ t('wizard.income.verified') }}</span>
        }
      </span>
      <div class="align-self-center text-nowrap">
        <div class="d-flex">
          <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            (click)="onDeleteClicked($event)">
            <span class="svg-icon svg-icon-3">
              <duotone-trash-svg-icon></duotone-trash-svg-icon>
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="text-start mt-3 px-2">
      @if (income.position) {
        <div>
          <label class="form-label line-item-text" style="min-width: 6.5rem;"> {{income.isOther ? t('wizard.income.description') : t('wizard.income.position')}}: </label>
          <span> {{income.position}} </span>
          <span>{{!income.isCurrent ? " " + t('wizard.income.former') : ""}}</span>
        </div>
      }
      @if (income.startDate) {
        <div>
          <label class="form-label line-item-text" style="min-width: 6.5rem;"> {{ t('wizard.income.startDate') }}: </label>
          <span> {{income.startDate| date}} </span>
        </div>
      }
      @if (income.endDate) {
        <div>
          <label class="form-label line-item-text" style="min-width: 6.5rem;"> {{ t('wizard.income.endDate') }}: </label>
          <span> {{income.endDate| date}} </span>
        </div>
      }
      @if (income.monthlyPay) {
        <div>
          <label class="form-label line-item-text" style="min-width: 6.5rem;"> {{ t('wizard.income.monthlyPay') }}: </label>
          <span> {{income.monthlyPay| currency}} </span>
        </div>
      }
      @if (income.type === 'Base') {
        <div class="shown-only-monthly-income-link">
          <span (click)="onEditIncomeClicked($event)" class="line-item-text">
            {{ t('wizard.income.incomeDetails') }} <i class="text-primary fa fa-eye"></i></span>
        </div>
      }
    </div>
  </div>
</div>
</ng-container>
